export function enableTap(object, handler) {
  object.interactive = true
  object.buttonMode = true
  object.on('pointertap', () => {
    handler()
  })
}
